import { z } from 'zod';

import { AnalyticsConfigurationSchema } from './analytics';
import { IntegrationType, integrationUrl } from './integration';
import { makeEndpoint } from '../common';

export const GtmIntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true,
}).extend({
  defaultTracking: z.boolean(),
});

export const Ga4IntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true,
}).extend({
  enabled: z.boolean(),
});

export const GetGtmIntegrationConfigEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId }: { brandId: string }) =>
    `${integrationUrl({ brandId, integrationType: IntegrationType.GTM_ANALYTICS })}/config`,
  responseSchema: GtmIntegrationConfigResponse,
  requestSchema: z.void(),
});
